<section class="phs-cand">
  <header class="phs-cand__intro">
    <h2 class="phs-cand__title">PHS-iconen — FontAwesome-kandidaten</h2>
    <p class="phs-cand__hint">
      Hover een icoon voor de FA-naam. Het eerste icoon is de huidige default; daarnaast staan de varianten.
      <i class="fa-solid fa-triangle-exclamation phs-cand__dup" aria-hidden="true"></i>
      = het default-icoon wordt elders ook gebruikt → kies eventueel een variant.
    </p>
  </header>

  @for (group of groups(); track group.title) {
    <div class="phs-cand__group">
      <h3 class="phs-cand__group-title">{{ group.title }}</h3>

      <div class="phs-cand__table">
        <div class="phs-cand__row phs-cand__row--head">
          <span class="phs-cand__c-label">Keynote</span>
          <span class="phs-cand__c-fa">FontAwesome (default + varianten)</span>
        </div>

        @for (row of group.rows; track $index) {
          <div class="phs-cand__row" [class.is-sub]="row.sub">
            <span class="phs-cand__c-label">{{ row.label }}</span>

            <span class="phs-cand__c-fa">
              @for (f of row.fa; track f; let first = $first) {
                <i class="fa-solid fa-{{ f }} phs-cand__fa-ic" [class.is-default]="first" [title]="'fa-' + f" aria-hidden="true"></i>
              }
              @if (row.duplicate) {
                <i class="fa-solid fa-triangle-exclamation phs-cand__dup" title="Standaard-icoon wordt elders ook gebruikt — kies eventueel een variant" aria-hidden="true"></i>
              }
            </span>
          </div>
        }
      </div>
    </div>
  }
</section>
